import _pt from 'prop-types';
import React, { useRef } from 'react';
import { jsx } from '@emotion/core';
import { observer } from 'mobx-react';
import { isMobileView } from "../helpers/layoutUtils.js";
import { withStores } from "../contexts/StoresContext.js";
import useStores from "../hooks/useStores.js";
import PdfToolbar from "./PdfToolbar.js";
import DrawablePdfToolbar from "./DrawablePdfToolbar.js";
import MobilePdfToolbar from "./MobilePdfToolbar.js";

var PdfWrapper = function PdfWrapper(_ref) {
  var children = _ref.children,
      _ref$drawable = _ref.drawable,
      drawable = _ref$drawable === void 0 ? false : _ref$drawable;
  var ref = useRef(null);

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  pdfStore.setPdfWrapperRef(ref);
  return jsx(React.Fragment, null, drawable && jsx(DrawablePdfToolbar, null), !drawable && !isMobileView() && jsx(PdfToolbar, null), jsx("div", {
    id: "pdf-wrapper",
    className: "d-flex flex-column flex-grow-1 overflow-auto bg-dark" // Workaround for a Safari bug: https://github.com/philipwalton/flexbugs/issues/197
    ,
    style: {
      flex: 1
    },
    ref: ref
  }, children), !drawable && isMobileView() && jsx(MobilePdfToolbar, null));
};

PdfWrapper.displayName = "PdfWrapper";
PdfWrapper.propTypes = {
  children: _pt.node.isRequired,
  drawable: _pt.bool
};
var PdfWrapper$1 = withStores(observer(PdfWrapper));
export default PdfWrapper$1;